import React, { useState } from 'react';
import styles from "./signIn.module.css"
import { useDispatch, useSelector } from 'react-redux';
import { loginWithPhone } from '../../../redux/loginSlice';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { unwrapResult } from '@reduxjs/toolkit';
import { setData, setMode, setVisible } from '../../../redux/authModelSlice';
// import PhoneInput from 'react-phone-input-2';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';



const SignIn = () => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const { visible } = useSelector(state => state.model)

    const openOtpModal = (value, mode) => {
        dispatch(setData(value))
        dispatch(setMode(mode))
        dispatch(setVisible('otp'))
    };

    const schema = yup.object().shape({
        phone: yup
            .string()
            .matches(/^\+?\d{12,15}$/, "Invalid phone number")
            .required("Phone number is required"),
    });

    const {
        errors, values, touched, handleBlur, handleSubmit, resetForm, setFieldValue
    } = useFormik({
        initialValues: {
            phone: '',
        },
        validationSchema: schema,
        onSubmit: async (values) => {
            setLoading(true);
            try {

                const payload = {
                    phone: values.phone.replace(/\D/g, "")
                };

                const result = await dispatch(loginWithPhone(payload));
                unwrapResult(result)
                resetForm()
                const mode = 'loginwithphone'
                openOtpModal(payload, mode);
            } catch (error) {
                console.error('Login failed:', error);
            } finally {
                setLoading(false);
            }
        }
    });

    if (visible != 'signin') {
        return null
    }

    return (
        <>
            <div className={styles.popupOverlay} >
                <div className={styles.login_container}>
                    <div className={styles.image_section}>
                        <img src="/assets/loginImg.jpeg" alt="login" />
                    </div>
                    <div className={styles.form_section}>
                        <button className={styles.closeButton} onClick={() => dispatch(setVisible(''))}>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.6841 8.31641L8.31633 23.6842" stroke="#C4C4C4" stroke-width="2" stroke-linecap="round" />
                                <path d="M23.6833 23.6855L8.3156 8.3178" stroke="#C4C4C4" stroke-width="2" stroke-linecap="round" />
                            </svg>
                        </button>
                        <div className={styles.formLogo}>
                            <img src="/pavithrajewelslogo.png" alt="logo" />
                        </div>
                        <h2>Hello, Let's Sign In</h2>
                        <p>Please register or sign in.</p>
                        <div className={styles.form_container}>
                            <form>
                                <div style={{ width: '100%', }}>
                                    <label>Phone Number*</label>

                                    <PhoneInput
                                        defaultCountry="in"
                                        value={values.phone}
                                        onChange={(value) => setFieldValue("phone", value)}
                                        onBlur={handleBlur}
                                        name="phone"
                                        className={styles.phoneInput}
                                    />
                                    {
                                        errors.phone && touched.phone && <div style={{ fontSize: 12, color: '#FE671F' }}>{errors.phone}</div>
                                    }
                                </div>

                                <button className={styles.formButton} type="submit" onClick={handleSubmit} disabled={loading}>{loading ? 'please wait' : "Sign In"}</button>
                            </form>
                            <div className={styles.loginWithMail} onClick={() => dispatch(setVisible('loginwithmail'))}>
                                Login With Email
                            </div>
                            <div className={styles.newuser} onClick={() => dispatch(setVisible('signup'))}>
                                <p className={styles.signup}>
                                    Create an Account
                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="10.5" y="9.09375" width="0.802992" height="5.62095" transform="rotate(-45 10.5 9.09375)" fill="black" />
                                        <rect x="14.4756" y="11.9336" width="0.802992" height="5.62095" transform="rotate(45 14.4756 11.9336)" fill="black" />
                                    </svg>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SignIn;
